import Vue from 'vue'

// Lib imports
import moment from 'moment'

Vue.prototype.$moment = moment
